import { arrayBufferToBase64, base64ToArrayBuffer } from "./base64"

export interface Cryptor {
    encrypt(value: string): Promise<string>

    decrypt(value: string): Promise<string>
}
export class AesCryptor implements Cryptor {
    private static ALGORITHM = "AES-GCM"
    private readonly key

    constructor(secretBase64: string) {
        const decoded = base64ToArrayBuffer(secretBase64)
        this.key = crypto.subtle.importKey("raw", decoded, AesCryptor.ALGORITHM, true, ["encrypt", "decrypt"])
    }

    async encrypt(value: string): Promise<string> {
        /*                                      */
        const iv = crypto.getRandomValues(new Uint8Array(12))
        const encrypted = await crypto.subtle.encrypt(
            {
                name: AesCryptor.ALGORITHM,
                iv,
            },
            await this.key,
            new TextEncoder().encode(value),
        )
        const ivAndEncrypted = new Uint8Array([...iv, ...new Uint8Array(encrypted)])
        return arrayBufferToBase64(ivAndEncrypted.buffer)
    }

    async decrypt(value: string): Promise<string> {
        /*                                      */
        const decoded = base64ToArrayBuffer(value)
        const iv = new Uint8Array(decoded.slice(0, 12))
        const encrypted = new Uint8Array(decoded.slice(12))
        const decrypted = await crypto.subtle.decrypt(
            {
                name: AesCryptor.ALGORITHM,
                iv,
            },
            await this.key,
            encrypted,
        )
        return new TextDecoder().decode(decrypted)
    }
}
